import { render, staticRenderFns } from "./restbookset.vue?vue&type=template&id=a28ea698&scoped=true&"
import script from "./restbookset.vue?vue&type=script&lang=js&"
export * from "./restbookset.vue?vue&type=script&lang=js&"
import style0 from "./restbookset.vue?vue&type=style&index=0&id=a28ea698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28ea698",
  null
  
)

export default component.exports